import type { UAPStyleMap } from '../../@types';

const getOutlookPlacementBaseStyles = (_theme?: object): UAPStyleMap => ({
  placementCard: {
    display: 'block',
    border: '1px solid #C8C8C8',
    margin: 'auto',
    overflow: 'hidden',
    position: 'relative !important',
    background: '#fff',
    boxSizing: 'content-box',
    boxShadow: 'none',

    '& .placement-card-content': {
      width: '100%',
      height: '100%',
    },
  },

  placementTextContainer: undefined,

  placementBusinessNameWithAdsLabel: undefined,

  placementShortHeadline: undefined,

  placementDescription: undefined,

  placementLogoContainer: undefined,
});


export const getResponsiveOutlookMobilePlacementStyles = (theme: object) => {
  const { placementCard, ...baseStyles } = getOutlookPlacementBaseStyles(theme);
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,
      height: 80,
      borderRadius: '5.11px',
      padding: '5px 10px 5px 15px',
      '& .placement-card-content': {
        display: 'flex',
        flexDirection: 'row',
      },
    },

    placementTextContainer: {
      display: 'block',
      fontSize: 10,
      lineHeight: '16px',
      color: '#0078d4',
      cursor: 'pointer',
      overflow: 'hidden',
      '&:hover': {
        color: '#004578',
      },
    },

    placementBusinessNameWithAdsLabel: {
      color: 'black !important',
      fontSize: '20px !important',
      maxWidth: 300,
      marginTop: '0px !important',
      lineHeight: '30px !important',
      verticalAlign: 'middle',

      '& .ads-label': {
        color: 'white !important',
        width: 'auto',
        height: 15,
        margin: '0 4px 0 0 !important',
        display: 'inline-block',
        padding: '0 4px !important',
        lineHeight: '15px !important',
        verticalAlign: 'middle',
        backgroundColor: 'blue !important',
        border: 'unset !important',
        borderRadius: '4px !important',
      },

      '& .business-name': {
        color: 'unset !important',
        padding: 'unset !important',
        fontSize: 'unset !important',
        marginTop: 'unset !important',
        lineHeight: 'unset !important',
      },
    },

    placementShortHeadline: {
      fontSize: 13,
      marginTop: 2,
      fontWeight: 200,
      lineHeight: '19.5px',
      paddingBottom: 5,
    },

    placementDescription: {
      color: 'black',
      fontSize: 13,
      marginTop: 2,
      lineHeight: '19.5px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      whiteSpace: 'nowrap',
    },
    placementLogoContainer: {
      paddingTop: 8,
      paddingRight: 16,
      '& .cropped-image-view': {
        borderRadius: '50%',
      },
    },
  };
  return styles;
};


export const getResponsiveOutlookWebPlacementStyles = (theme: object) => {
  const { placementCard, ...baseStyles } = getOutlookPlacementBaseStyles(theme);
  const styles = {
    ...baseStyles,

    outlookWebCardRoot: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },

    placementCard: {
      ...placementCard,
      borderRadius: 0,
      width: '100%',
      boxSizing: 'border-box',
      border: 'none',
      '& .placement-card-content': {
        display: 'flex',
        flexDirection: 'row',
        minWidth: 0,
        border: '1px solid #C8C8C8',
      },
    },

    placementTextContainer: {
      fontSize: 10,
      lineHeight: '16px',
      color: '#0078d4',
      cursor: 'pointer',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      minWidth: 0,
      '& .logo-and-businessname-container': {
        display: 'inline-block',
        position: 'relative',
      },
    },

    placementBusinessNameWithAdsLabel: {
      display: 'inline-block !important',
      margin: '0px 10px 0px 0px !important',
      verticalAlign: 'middle',

      '& .ads-label': {
        color: 'white !important',
        width: 'auto',
        height: 13,
        margin: '0 4px 0 0 !important',
        display: 'inline-block',
        padding: '0 4px !important',
        lineHeight: '15px !important',
        verticalAlign: 'middle',
        backgroundColor: 'blue !important',
        border: 'unset !important',
        borderRadius: '4px !important',
        opacity: '90%',
        position: 'relative',
        top: -2.5,
      },

      '& .business-name': {
        color: 'black !important',
        fontSize: '10px !important',
        lineHeight: '16px !important',
        padding: '4px 0px !important',
      },
    },

    placementShortHeadline: {
      display: 'inline-block',
      color: 'blue',
      padding: 4,
      fontWeight: 200,
      paddingBottom: 5,
      '&:before': {
        content: '" "',
        border: 'solid gray',
        display: 'inline-block',
        padding: '2px',
        transform: 'rotate(45deg) translateY(-3px)',
        borderWidth: '0 1.5px 1.5px 0',
        marginRight: 10,
        position: 'relative',
        left: -4,
      },
      '&::after': {
        content: '"*"',
        display: 'inline',
        padding: 4,
        color: 'gray',
        position: 'relative',
        left: 4,
      },
    },

    placementDescription: {
      display: 'inline-block',
      color: 'black',
      padding: 4,
      flex: '1 1 0px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      paddingBottom: 5,
    },

    placementLogoContainer: {
      padding: [2, 8, 2, 8],
      '& .cropped-image-view': {
        borderRadius: '50%',
      },
    },
  };
  return styles;
};
